import React from "react";
import logo from "./assets/logo.png";

function Home() {
  return (
    <div className="home-section">
      <div className="home-container">

        <div className="home-left">
          <img src={logo} alt="FD Ventilacie Logo" className="home-logo" />
        </div>

        <div className="home-right">
          <h1>F.D. Ventilacie</h1>
          <h3>Professional Ventilation Systems in North Macedonia</h3>

          <p>
            We provide complete ventilation solutions for residential,
            commercial and industrial facilities across North Macedonia.
          </p>

          <p>
            Our services include air duct systems, pipe insulation,
            Armaflex solutions and full ventilation installation
            for homes, cafés, sports halls and various facilities.
          </p>

          <div className="home-buttons">
            <a href="/contact" className="btn-primary">
              Request a Quote
            </a>

            <a href="/work" className="btn-outline">
              View Projects
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Home;
